import inherited from 'mastodon/locales/ms.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
